module.exports = __webpack_public_path__ + "static/media/GrubHub_logo.00ad9288.png";